import { createContext, useContext } from 'react';
const SheetContext = /*#__PURE__*/createContext(null);
export default SheetContext;
export const useSheet = () => useContext(SheetContext);